import { defineComponent as _defineComponent } from 'vue'
import { User } from "@/CodegenTypes";

import DDGameSettingForm from "@/components/modules/account/DDGameSettingForm.vue";
import TTGameSettingForm from "@/components/modules/account/TTGameSettingForm.vue";
import { queries } from "@/apollo";
import { computed, ref } from "vue";
import { useQuery } from "@vue/apollo-composable";
import { useTranslation } from "@/store/translation";


export default /*#__PURE__*/_defineComponent({
  __name: 'GameSettingFormModal',
  props: {
    upline: null,
    userId: null,
    value: { type: Boolean }
  },
  emits: ["input"],
  setup(__props: any, { emit }) {

const props = __props as {
  upline: User;
  userId: User['userId'];
  value: boolean;
};

const selectedAppModeTab = ref(0);

const { $t } = useTranslation();



const userId = computed(() => props.userId);

const { result } = useQuery(
  queries.user,
  {
    userId
  }
)



function resetTab() {
  selectedAppModeTab.value = 0;
}


function toggleModal(val: boolean) {
  emit("input", val);
}

return { __sfc: true,selectedAppModeTab, $t, props, userId, result, emit, resetTab, toggleModal, DDGameSettingForm, TTGameSettingForm }
}

})